export const workflowsApiPaths = <const>{
    getWorkflowVersionDocumentFields: 'templates/getWorkflowVersionDocumentFields',
    getWorkflows: 'templates/select',
};
